module.exports = __webpack_public_path__ + "static/media/navigator_lod_2.ba161dd0.glb";